import * as React from "react";

import { CircularProgress, Box } from "@mui/joy";
import Typography from "@mui/joy/Typography";
import FeatherIcon from "feather-icons-react";

export const Loading = () => (
    <Box sx={{ padding: "240px 0", textAlign: "center" }}>
        <CircularProgress size="lg" thickness={2}>
            <FeatherIcon icon="alert-triangle"/>
        </CircularProgress>
        <Typography>
            Loading...
        </Typography>
    </Box>
);
